import React, { createContext, useContext, useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import SecondHeader from "../components/SecondHeader";
import { ThemeContext } from "../state/ThemeContext";
import { useUser } from "../state/UserContext";
import { useLocation } from "react-router-dom";

export const MenuContext = createContext();

const Layout = ({ page }) => {
  const [isPhoneScreen, setIsPhoneScreen] = useState(window.innerWidth <= 767);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { theme } = useContext(ThemeContext);
  const { userData, setUser } = useUser();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const myParam = searchParams.get("data");

    if (myParam) {
      const { user, token } = JSON.parse(myParam);
      setUser(user);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
    }
  }, [location.search]);
  useEffect(() => {
    localStorage.setItem("theme-color-light", "rgba(22, 128, 4, 0.65)");
    localStorage.setItem("theme-color-input", "#F7FBF7");
    localStorage.setItem("theme-color", "#168004");
    const mediaQueryPhone = window.matchMedia("(max-width: 767px)");
    const handleResizePhone = (event) => {
      setIsPhoneScreen(event.matches);
    };

    mediaQueryPhone.addListener(handleResizePhone);
    // Initial check
    setIsPhoneScreen(mediaQueryPhone.matches);

    // Remove the listener when the component unmounts
    return () => {
      mediaQueryPhone.removeListener(handleResizePhone);
    };
  }, []);
  return (
    //todo fix the two headers for the two different dashboards
    <div
      className={`flex h-screen dark:bg-dark1  ${theme}`}
      style={{
        backgroundColor: theme === "dark" ? "#121611" : "#fff",
      }}
    >
      <MenuContext.Provider value={[mobileMenuOpen, setMobileMenuOpen]}>
        {(mobileMenuOpen || !isPhoneScreen) && <Sidebar />}
        <div className="main-content overflow-y-auto flex-1 w-[100%]">
          {/* <Header />  */}
          <SecondHeader />
          <div
            className="h-[1px] w-full"
            style={{
              backgroundColor: theme === "dark" ? "#242424" : "#e5e7eb",
            }}
          />
          {page}
        </div>
      </MenuContext.Provider>
    </div>
  );
};

export default Layout;
